import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { SearchableSelectOption } from '@/components/SearchableSelect/SearchableSelect.types';
import UserAvatar from '@/components/UserAvatar';

const TicketWatchersAvatar = ({
  option
}: {
  option: SearchableSelectOption;
}) => {
  return (
    <UserAvatar
      name={option.label}
      {...(option.userId === 0 && {
        icon: <FontAwesomeIcon icon={faUsers} />
      })}
      {...(option.userId !== 0 && {
        pondurance: option.internal
      })}
    />
  );
};

export default TicketWatchersAvatar;
